// The hours list (board 25 v2 هـ, hours--default / --closed-day): one row per
// day from Saturday — toggle, the name, two 40 px time boxes while open,
// «مغلق» / «عطلة · مغلق» pill while closed (the weekend row is cloud-tinted
// and stays openable), «نسخ إلى بقية الأيام» on the first row (a link under
// the list on a phone).

import { Copy } from 'lucide-react';
import { HOURS } from '../copy';
import { WEEK, type HoursDraft } from '../state';

export interface DayRowsProps {
  hours: HoursDraft;
  onToggle: (i: number) => void;
  onTime: (i: number, key: 'from' | 'to', v: string) => void;
  onCopy: () => void;
  mobile?: boolean;
  /** Work days (shape 3): the toggles only — no time boxes, no copy. */
  timesHidden?: boolean;
}

export function DayRows({ hours, onToggle, onTime, onCopy, mobile, timesHidden }: DayRowsProps) {
  return (
    <>
      <div className="onb-days" role="group" aria-label={HOURS.crumb} data-testid="onb-days">
        {WEEK.map((d, i) => {
          const day = hours.days[i];
          return (
            <div key={d.weekday} className="onb-day" data-weekend={d.weekend ? 'true' : undefined} data-open={day.open ? 'true' : 'false'}>
              <button type="button" role="switch" aria-checked={day.open} aria-label={d.name} className="onb-day-toggle" onClick={() => onToggle(i)}>
                <span className="onb-day-knob" aria-hidden="true" />
              </button>
              <span className="onb-day-name">{d.name}</span>
              <div className="onb-day-times">
                {day.open && timesHidden ? null : day.open ? (
                  <>
                    <input type="time" className="onb-time ltr" dir="ltr" step={900} value={day.from} aria-label={`${d.name} · ${HOURS.from}`} data-testid={`onb-from-${i}`} onChange={(e) => onTime(i, 'from', e.target.value)} />
                    <span className="onb-day-dash" aria-hidden="true">
                      –
                    </span>
                    <input type="time" className="onb-time ltr" dir="ltr" step={900} value={day.to} aria-label={`${d.name} · ${HOURS.to}`} data-testid={`onb-to-${i}`} onChange={(e) => onTime(i, 'to', e.target.value)} />
                  </>
                ) : (
                  <span className="onb-day-closed">{d.weekend ? HOURS.weekendClosed : HOURS.closed}</span>
                )}
              </div>
              {i === 0 && !mobile && !timesHidden && day.open && (
                <button type="button" className="onb-day-copy" onClick={onCopy} data-testid="onb-copy-days">
                  <Copy aria-hidden="true" />
                  {HOURS.copy}
                </button>
              )}
            </div>
          );
        })}
      </div>
      {mobile && !timesHidden && hours.days[0].open && (
        <button type="button" className="onb-day-copy onb-day-copy--link" onClick={onCopy} data-testid="onb-copy-days">
          <Copy aria-hidden="true" />
          {HOURS.copyMobile}
        </button>
      )}
    </>
  );
}
